import { useNavigate, useLocation } from "react-router-dom";
import { Calendar, Clock, ListFilter, CheckSquare, Tag, Palette, Sliders, LogOut, CalendarDays, Network, Bot } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useUI } from "@/context/UIContext";
import { motion } from "framer-motion";

const NAV = [
  { id: "calendar", label: "Calendar", icon: Calendar, path: "/calendar" },
  { id: "mindmap", label: "Mind Map", icon: Network, path: "/calendar?view=mindmap" },
  { id: "upcoming", label: "Upcoming", icon: ListFilter, path: "/upcoming" },
  { id: "tasks", label: "Tasks", icon: CheckSquare, path: "/tasks" },
  
  
  { id: "categories", label: "Categories", icon: Tag, path: "/categories" },
  { id: "themes", label: "Theme Studio", icon: Palette, path: "/themes" },
  { id: "settings", label: "Settings", icon: Sliders, path: "/settings" },
];

export function Sidebar({ onNavigate }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  return (
    <aside className="w-64 h-full flex flex-col shrink-0" style={{ background: "var(--bg-sidebar)", borderRight: "1px solid var(--border-subtle)" }}>
      <div className="px-5 py-5 flex items-center gap-3">
        <div className="w-10 h-10 rounded-2xl flex items-center justify-center accent-gradient-bg shadow-lg">
          <CalendarDays size={20} className="text-white" />
        </div>
        <div>
          <h1 className="font-display font-extrabold text-lg leading-none" style={{ color: "var(--text-primary)" }}>ChronoGraph</h1>
          <p className="text-[10px] tracking-widest uppercase mt-1" style={{ color: "var(--text-muted)" }}>Studio</p>
        </div>
      </div>

      <nav className="flex-1 px-3 space-y-1 mt-2">
        {NAV.map((item) => {
          const active = location.pathname.startsWith(item.path);
          const Ico = item.icon;
          return (
            <button key={item.id} onClick={() => { navigate(item.path); onNavigate?.(); }}
              className="relative w-full flex items-center gap-3 px-3.5 py-2.5 rounded-xl text-sm font-medium transition-all group"
              style={{ color: active ? "var(--text-primary)" : "var(--text-secondary)" }}
              data-testid={`sidebar-nav-${item.id}`}>
              {active && <motion.div layoutId="nav-active" className="absolute inset-0 rounded-xl" style={{ background: "color-mix(in srgb, var(--accent-primary) 18%, transparent)", border: "1px solid var(--border-active)" }} transition={{ type: "spring", stiffness: 400, damping: 32 }} />}
              <Ico size={18} className="relative z-10 shrink-0" style={{ color: active ? "var(--accent-primary)" : "var(--text-muted)" }} />
              <span className="relative z-10">{item.label}</span>
            </button>
          );
        })}
      </nav>

      <div className="p-3">
        <div className="flex items-center gap-3 p-2.5 rounded-2xl" style={{ background: "var(--bg-card)" }}>
          {user?.picture
            ? <img src={user.picture} alt="" className="w-9 h-9 rounded-full object-cover" referrerPolicy="no-referrer" />
            : <div className="w-9 h-9 rounded-full accent-gradient-bg flex items-center justify-center text-white font-bold text-sm">{user?.name?.[0] || "U"}</div>}
          <div className="min-w-0 flex-1">
            <p className="text-sm font-semibold truncate" style={{ color: "var(--text-primary)" }}>{user?.name}</p>
            <p className="text-[10px] truncate" style={{ color: "var(--text-muted)" }}>{user?.email}</p>
          </div>
          <button onClick={logout} className="p-1.5 rounded-lg hover:opacity-70" style={{ color: "var(--text-muted)" }} data-testid="logout-btn"><LogOut size={16} /></button>
        </div>
      </div>
    </aside>
  );
}
